

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_4kc395hgpa = () => {
                    
                }
                if (window.beaejQuery) {
                    jsHandle_4kc395hgpa()
                } else {
                    window.beaePageJS.push(jsHandle_4kc395hgpa)
                }
            